import { create } from "zustand";
import { toast } from "react-toastify";

/* =======================
   TYPES
======================= */
export type JobPreferenceItem = {
  preferenceName: number;
};

type JobPreferenceState = {
  loading: boolean;
  updateJobPreferences: (data: JobPreferenceItem[]) => Promise<boolean>;
};

/* =======================
   HELPER
======================= */
const getAccessToken = (): string | null => {
  if (typeof window === "undefined") return null;

  try {
    const raw = localStorage.getItem("auth-storage");
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed?.state?.accessToken || null;
  } catch (e) {
    console.error("❌ Failed to parse auth token:", e);
    return null;
  }
};

/* =======================
   STORE
======================= */
export const useJobPreferenceStore = create<JobPreferenceState>((set) => ({
  loading: false,

  updateJobPreferences: async (data) => {
    try {
      set({ loading: true });

      const token = getAccessToken();
      if (!token) throw new Error("No access token");

      const payload = {
        job_preference_ids: data.map((item) =>
          Number(item.preferenceName)
        ),
      };

      const res = await fetch(
        "https://admin.talentlinkindo.com/api/candidate/job-preferences",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Update job preferences failed");

      toast.success("Job preferences updated successfully");
      return true;
    } catch (err) {
      console.error(err);
      toast.error("Failed to update job preferences");
      return false;
    } finally {
      set({ loading: false });
    }
  },
}));
